import config from '../../config'
import moment from 'moment'

export const selectCountries = (locale) => {
  return locale.countries.map(country => ({
    id: country.id,
    name: country.name_[locale.selectedLanguage.slug] || country.name,
    number: country.number,
    icon: country.icon,
  }))
}

export const selectSosNumbers = (locale) => {
  const country = locale.countries.find(country => country.id === locale.selectedCountry)
  if (!country) {
    return []
  }

  return country
    .numbers
    .map(number => ({
      ...number,
      name: number.name[locale.selectedLanguage.slug]
    }))
}

export const selectSidebarMenu = (state) => {
  return state.content.sections.map(section => {
    const sectionName = section.name[state.locale.selectedLanguage.slug] || section.name[config.defaultLang]
    return {
      id: section.id,
      name: sectionName,
      icon: 'fa fa-long-arrow-right',
      url: `/sections/${section.id}`
    }
  })
}

export const selectHolidays = (locale) => {
  const country = locale.countries.find(country => country.id === locale.selectedCountry)
  if (!country) {
    return []
  }

  return country
    .holidays
    .map(holiday => {
      const momentDate = moment(holiday.date)
      return {
        id: holiday.date,
        title: holiday.name[locale.selectedLanguage.slug],
        description: holiday.title[locale.selectedLanguage.slug],
        allDay: true,
        start: momentDate.toDate(),
        end: momentDate.add(1, 'day').toDate()
      }
    })
}

export const selectUpcomingHoliday = (state) => {
  const country = state.locale.countries.find(country => country.id === state.locale.selectedCountry)
  if (!country) {
    return []
  }
  const langSlug = state.locale.selectedLanguage.slug

  const holidays = []

  for (const holiday of country.holidays) {
    const daysUntilHoliday = moment(holiday.date).diff(moment(), 'days')
    if (daysUntilHoliday < 0) {
      continue
    }
    if (daysUntilHoliday < config.daysBeforeHolidayNotification) {
      let msg = `${moment(holiday.date).format('DD.MM.YYYY')} - ${holiday.name[langSlug]}`
      if (holiday.title[langSlug]) {
        msg += ` (${holiday.title[langSlug]})`
      }
      holidays.push(msg)
    }
  }

  return holidays
}
